<template>
  <div class="row restaurante">
    <div class="small-12 medium-5 large-4 columns">
      <p class="restaurante_titulo">{{ titulo }}</p>
    </div>
    <div class="small-12 medium-7 large-8 columns">
      <p class="restaurante_descricao" v-html="descricao"></p>
      <div class="row restaurante_horas">
        <div class="small-1 medium-1 large-1 columns">
          <img class="icon_horario_restaurante" :src="Image" />
        </div>
        <div class="small-11 medium-11 large-11 columns">
          <p class="restaurante_horario" v-html="horario"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image from "@/assets/images/icons_sas-19.png";

export default {
  props: ["titulo", "horario", "descricao"],
  setup(){
    return {
      Image
    }
  }
}
</script>

<style lang="scss" scoped>
.restaurante {
  border: 2px solid #acacad;
  margin-bottom: 30px;
  padding: 30px;
}

.restaurante_titulo {
  font-family: 'Montserrat Bold';
  font-size: 22px;
  margin-top: 0px;
  color: #6eb7ec;
}

.restaurante_descricao {
  font-family: "PT Sans";
  font-size: 17px;
  margin-top: 9px;
  color: #494d52eb;
  font-size: 17px;
}

.restaurante_horario {
  font-family: "PT Sans Bold";
  font-size: 17px;
  color: #222b35ed;
}

.restaurante_horario {
  display: contents;
}

.icon_horario_restaurante {
  width: 55px;
}

.restaurante_horas .columns {
  padding: 0px;
}

.restaurante_horas .columns:nth-of-type(2) {
  padding-top: 10px;
  padding-left: 10px;
}

.noticiabackgroundcolor.alimentacao {
  padding-bottom: 85px;
}

@media (max-width: 1080px) {

  .restaurante_titulo {
    font-size: 18px !important;
  }

}


@media (max-width: 767px) {

  .restaurante_descricao {
    font-size: 14px;
    line-height: 2;
    font-family: 'PT Sans';
    color: #333333;
  }

  .restaurante_titulo {
    margin-bottom: 0px;
  }

  .restaurante_horario {
    font-size: 14px;
  }

  .restaurante_horas .columns:nth-of-type(2) {
    padding-top: 0px;
  }

  .noticiabackgroundcolor.alimentacao {
    padding-bottom: 35px;
  }

}
</style>